<template>
    <header class="site-header">
        <div class="header-container">
            <a href="#" class="logo" @click="goBack">
                <!--merged image-->
                <div class="logo-images">
                    <img class="logo-icon" src="../assets/images/logo-icon-footer.svg" alt="GPET VET logo icon">
                    <img class="logo-text" src="../assets/images/logo-text-footer.svg" alt="GPET VET logo text">
                </div>
            </a>
            <a href="#" class="back-link" @click="goBack">
                <img src="../assets/images/icon-back.svg" alt="Back icon">
                <span class="back-text">Quay trở lại</span>
            </a>
        </div>
    </header>
</template>

<script>
export default {
    name: 'HeadComp',
    methods: {
        goBack() {
            this.$router.back();
        }
    }
}
</script>

<style scoped>
.site-header {
    background-color: var(--primary-color);
    padding: 16px 70px;
    box-shadow: 0px 3px 5px 0px rgba(197, 205, 210, 0.25);
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1340px;
    margin: 0 auto;
}

.logo-images {
    display: flex;
    align-items: center;
    gap: 10px;
}

.back-link {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--white-color);
    font-size: 18px;
    font-weight: 400;
    text-decoration: none;
}

.logo-icon {
    width: 41px;
}

.logo-text {
    width: 128px;
}

@media (max-width: 768px) {
    .site-header {
        padding: 16px 20px;
    }

    .back-link span {
        display: none;
    }
}
</style>